<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-col cols="12" sm="12">
            <v-card class="box">
                <v-col cols="12" sm="12">
                    <v-toolbar class="toolbar" flat dense>
                        <v-toolbar-title>
                            <strong> Teacher Comments Entry </strong>
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-row align="center" justify="center">
                        <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                            <v-autocomplete dense required outlined rounded color="#0F2027" v-model="ay" :items="ay_list" item-text="ay" item-value="id" label="Academic Year" persistent-hint hint="Please select academic year" />
                        </v-col>
                        <v-col cols="12" sm="4" md="4" class="pt-6 m-0">
                            <v-autocomplete dense required outlined rounded color="#0F2027" v-model="sem" :items="semester_list" item-text="sem" item-value="id" label="Semester" persistent-hint hint="Please select semester" />
                        </v-col>
                        <v-col cols="12" sm="2" md="2" class="pt-0 m-0" v-if="ay != null && sem != null">
                            <v-btn class="mt-6 button" :loading="loader" @click="getInstCourse">Proceed</v-btn>
                        </v-col>
                    </v-row>

                    <span v-if="instrructor_course_list != ''">
                        <!-- excel export btn code -->

                        <v-col cols="12" sm="12" md="12">
                            <!-- <v-btn color="success" outlined rounded>
                              <download-excel class="mr-2 pb-3 pt-2" :data="instrructor_course_list" :fields="table_fields" worksheet="MarksEntry" name="MarksEntry.xls"> <v-icon dark>mdi-file-excel</v-icon> Export </download-excel>
                          </v-btn> -->
                            <!-- <v-btn class="ma-2 no-display" rounded color="success" outlined @click="fnExcelReport('my-table-id', 'ReportCardCommentsEntryReport')" :loading="loader"><v-icon color="success">mdi-export</v-icon>Export</v-btn> -->
                        </v-col>
                        <!-- excel export btn code end -->

                        
                            <v-data-table v-if="instrructor_course_list.length > 0" dense :headers="headers1" :items="instrructor_course_list" :search="search" class="elevation-1 mytable">
                                <template v-slot:item.crs_off_learner="{ item }">
                                    <v-btn class="btn-css btn" @click="get_learners(item.crs_off_learner)">{{ item.crs_off_learner.length }}</v-btn>
                                </template>
                                <template v-slot:item.options="{ item }">
                                    <v-btn
                                        small
                                        class="button"
                                        @click="
                  getscheme_info(
                    item.courseassessmentscheme_id,
                    item.crs_off_id,
                    item.crs_off_learner,
                    item.divisionoffering_id,
                    item.crs_id
                  )
                "
                                    >
                                        Proceed
                                    </v-btn>
                                </template>
                            </v-data-table>
                        
                    </span>

                    <span v-if="ass_scheme_deatils_list != ''">
                        <v-dialog v-model="dialog_scheme" persistent max-width="1200px">
                            <v-card>
                                <v-toolbar class="toolbar" flat dense>
                                    <v-toolbar-title>
                                        <strong> Course scheme details </strong>
                                    </v-toolbar-title>
                                </v-toolbar>
                                <v-col cols="12" sm="12" md="12">
                                    <v-card class="box">
                                        <v-data-table
                                            v-if="
                      ass_scheme_deatils_list != '' &&
                      ass_scheme_deatils_list != 'No Scheme'
                    "
                                            dense
                                            :headers="headers2"
                                            :items="ass_scheme_deatils_list"
                                            class="elevation-1 mytable"
                                        >
                                            <template v-slot:item.options="{ item }">
                                                <v-btn
                                                    small
                                                    class="button"
                                                    @click="
                          assesmentschememarkentry(
                            item.ass_det_id,
                            item.courseoffering_id,
                            item.courseAssessmentScheme,
                          );
                          dialog_marks_entry = true;
                        "
                                                >
                                                    Proceed
                                                </v-btn>
                                            </template>
                                        </v-data-table>
                                    </v-card>
                                </v-col>
                                <v-row justify="center">
                                    <v-btn rounded class="button" @click="dialog_scheme = false">Close</v-btn>
                                </v-row>
                            </v-card>
                        </v-dialog>
                    </span>
                    <v-dialog fullscreen v-model="dialog_marks_entry" persistent max-width="1200px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Teacher Comments Entry </strong>
                                </v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn small rounded @click="dialog_marks_entry = false">Close</v-btn>
                            </v-toolbar>
                            <span v-if="rubricsScheme == 'NO'">
                                <span v-if="scheme_details != ''">
                                    <comments-entry :scheme_details="scheme_details" :remarks_list="remarks_list"></comments-entry>
                                </span>
                            </span>
                            <!-- <span v-if="rubricsScheme == 'YES'">
                              <marks-entry-rubrics :rubric_list="rubric_list" :scheme_details="scheme_details"></marks-entry-rubrics>
                          </span> -->
                            <center>
                                <v-btn rounded class="button" @click="dialog_marks_entry = false">Close</v-btn>
                            </center>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialog" persistent max-width="1200px">
                        <v-card>
                            <v-toolbar class="toolbar" flat dense>
                                <v-toolbar-title>
                                    <strong> Course Learners </strong>
                                </v-toolbar-title>
                            </v-toolbar>
                            <v-col cols="12" sm="12" md="12">
                                <v-card class="box" v-if="learners != ''">
                                    <v-row class="p-0 m-0" v-if="learners.length > 0">
                                        <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
                                        <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                                            <v-text-field class="search" v-model="search" append-icon="mdi-magnify" label="Search in table" single-line hide-details></v-text-field>
                                        </v-col>
                                    </v-row>
                                    <v-data-table v-if="learners.length > 0" dense :headers="headers" :items="learners" :search="search" class="elevation-1 mytable"> </v-data-table>
                                </v-card>
                            </v-col>
                            <v-row justify="center">
                                <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
                            </v-row>
                        </v-card>
                    </v-dialog>
                </v-col>
            </v-card>
        </v-col>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    import CommentsEntry from "./CommentEntry";
    //   import MarksEntryRubrics from "./MarksEntryRubrics";
    // import CommentEntry from './CommentEntry.vue';
    export default {
        components: {
            "comments-entry": CommentsEntry,
            //   "marks-entry-rubrics": MarksEntryRubrics
        },
        data() {
            return {
                snackbar_msg: null,
                snackbar: false,
                loader: false,
                color: "",
                ay_list: [],
                ay: null,
                semester_list: [],
                sem: null,
                search: null,
                dialog: false,
                dialog_scheme: false,
                dialog_marks_entry: false,
                rubricsScheme: null,
                instrructor_course_list: [],
                ass_scheme_deatils_list: [],
                learners: [],
                crs_off_learner: [],
                scheme_details: [],
                divisionoffering_id: null,
                crs_inst_id: null,
                rubric_list: [],
                table_fields: {
                    "Sr. No": "srno",
                    "Academic Year": "academicyear",
                    Semester: "semester",
                    "Course ": "crs_name",
                    Standard: "standard",
                    Division: "divisionoffering",

                    Student: "crs_off_learner.length",
                    "Mark Entry Type": "coursemarksentrytype",
                    "Course Type": "coursetype",
                    "Grading Scheme": "gradingscheme",
                    "Assessment Scheme": "courseassessmentscheme",
                },
                headers2: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Course",
                        align: "center",
                        sortable: false,
                        value: "crs_name",
                    },
                    {
                        text: "Assessment Type",
                        align: "left",
                        sortable: false,
                        value: "assessmenttype",
                    },
                    {
                        text: "Evaluation Type",
                        align: "left",
                        sortable: false,
                        value: "evaluationtype",
                    },
                    {
                        text: "Evaluated Marks",
                        align: "left",
                        sortable: false,
                        value: "evaluated_marks",
                    },
                    {
                        text: "Converted Marks",
                        align: "left",
                        sortable: false,
                        value: "converted_marks",
                    },
                    {
                        text: "Passing Marks %",
                        align: "left",
                        sortable: false,
                        value: "passing_marks",
                    },
                    {
                        text: "Action",
                        align: "center",
                        sortable: false,
                        value: "options",
                    },
                ],
                headers1: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Semester",
                        align: "center",
                        sortable: false,
                        value: "semester",
                    },
                    {
                        text: "Course",
                        align: "center",
                        sortable: false,
                        value: "crs_name",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "standard",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "divisionoffering",
                    },
                    {
                        text: "Student",
                        align: "center",
                        sortable: false,
                        value: "crs_off_learner",
                    },
                    {
                        text: "Mark Entry Type",
                        align: "center",
                        sortable: false,
                        value: "coursemarksentrytype",
                    },
                    {
                        text: "Course Type",
                        align: "center",
                        sortable: false,
                        value: "coursetype",
                    },
                    {
                        text: "Grading Scheme",
                        align: "center",
                        sortable: false,
                        value: "gradingscheme",
                    },
                    {
                        text: "Assessment Scheme",
                        align: "center",
                        sortable: false,
                        value: "courseassessmentscheme",
                    },
                    {
                        text: "Action",
                        align: "center",
                        sortable: false,
                        value: "options",
                    },
                ],
                headers: [
                    {
                        text: "Sr. No.",
                        sortable: false,
                        value: "srno",
                    },
                    {
                        text: "Academic Year",
                        align: "center",
                        sortable: false,
                        value: "academicyear",
                    },
                    {
                        text: "Standard",
                        align: "center",
                        sortable: false,
                        value: "std",
                    },
                    {
                        text: "Division",
                        align: "center",
                        sortable: false,
                        value: "div",
                    },
                    {
                        text: "PRN No",
                        align: "center",
                        sortable: false,
                        value: "registration_number",
                    },
                    {
                        text: "Roll No",
                        align: "center",
                        sortable: false,
                        value: "rollno",
                    },
                    {
                        text: "Name",
                        align: "center",
                        sortable: false,
                        value: "name",
                    },
                ],
                remarks_list: [],
                remarks: [],
            };
        },
        methods: {
            assesmentschememarkentry(ass_det_id, courseoffering_id, courseAssessmentScheme) {
                const data = {
                    courseoffering_id: courseoffering_id,
                    ass_det_id: ass_det_id,
                    courseAssessmentScheme: courseAssessmentScheme,
                    crs_off_learner: this.crs_off_learner,
                    ay: this.ay,
                    sem: this.sem,
                    divisionoffering_id: this.divisionoffering_id,
                    crs_inst_id: this.crs_inst_id,
                };
                axios
                    .post("/Examination/assesmentschememarkentry", data)
                    .then((res) => {
                        this.scheme_details = res.data.scheme_details;
                        this.rubricsScheme = res.data.rubricsScheme;
                        this.remarks_list = res.data.remarks_list;
                        if (this.rubricsScheme == "YES") {
                            this.rubric_list = res.data.rubric_list;
                        }
                    })
                    .catch((error) => {
                        this.overlay = true;
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            },
            getscheme_info(courseassessmentscheme_id, coff_id, crs_off_learner, divisionoffering_id, crs_inst_id) {
                this.crs_off_learner = crs_off_learner;
                this.divisionoffering_id = divisionoffering_id;
                this.crs_inst_id = crs_inst_id;
                const data = {
                    courseassessmentscheme_id: courseassessmentscheme_id,
                    coff_id: coff_id,
                    crs_off_learner: this.crs_off_learner,
                    ay: this.ay,
                    sem: this.sem,
                    divisionoffering_id: this.divisionoffering_id,
                    crs_inst_id: this.crs_inst_id,
                };
                axios
                    .post("/Examination/get_scheme_info", data)
                    .then((res) => {
                        this.ass_scheme_deatils_list = res.data.ass_scheme_deatils_list;
                        this.dialog_scheme = true;
                    })
                    .catch((error) => {
                        this.overlay = true;
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            },
            get_learners(crs_off_learner) {
                const data = {
                    crs_off_learner: crs_off_learner,
                    ay: this.ay,
                    sem: this.sem,
                };
                axios
                    .post("/Examination/get_learners_data", data)
                    .then((res) => {
                        this.learners = res.data.learners;
                        this.dialog = true;
                    })
                    .catch((error) => {
                        this.overlay = true;
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            },
            getInstCourse() {
                this.loader = true;
                const data = {
                    ay: this.ay,
                    sem: this.sem,
                };
                axios
                    .post("/examination/getInstCourse", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.instrructor_course_list = res.data.instrructor_course_list;
                            this.loader = false;
                        } else if (res.data.flag == "NO") {
                            this.showSnackbar("#b71c1c", "No courses offered.."); // show snackbar
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        this.loader = false;
                    })
                    .finally(() => {
                        //stop loader
                        this.loader = false;
                    });
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onload() {
                axios
                    .post("/examination/offerAssessmentScheme")
                    .then((res) => {
                        this.assessment_scheme_list = res.data.assessment_scheme_list;
                        this.ay_list = res.data.ay_list;
                        this.semester_list = res.data.semester_list_wws;
                        this.assessment_offer_list = res.data.assessment_offer_list;
                    })
                    .catch((error) => {
                        alert("Somthing went wrong!!!");
                    })
                    .finally(() => {
                        //stop loader
                    });
            },
        },
        mounted() {
            this.onload();
        },
    };
</script>
<style scoped>
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
    }

    .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
    }
</style>
